import request from '@/utils/request.js'

export function getproductlist(data) {
    return request.get('/api/H5/product/getproductlist', {
        params: data
    })
}

export function getproductdetail(data) {
    return request.get('/api/H5/product/getproductdetailv1', {
        params: data
    })
}

export function getproducttype(data) {
    return request.get('/api/H5/product/getproducttype', {
        params: data
    })
}

export function getactivitydatil(data) {
    return request.get('/api/H5/product/getactivitydatil', {
        params: data
    })
}

export function getactivityproduct(data) {
    return request.get('/api/H5/product/getactivityproduct', {
        params: data
    })
}

export function addproductColl(data) {
    return request.get('/api/H5/product/addproductColl', {
        params: data
    })
}

export function getproductbrand(data) {
    return request.get('/api/H5/product/getproductbrand', {
        params: data
    })
}

export function cancelColl(data) {
    return request.post('/api/H5/product/cancelColl', data)
}


export function getintegralproduct(data) {
    return request.get('/api/H5/product/getintegralproduct', {
      params: data
    })
}
  
export function getintegralproductdetail(data) {
    return request.get('/api/H5/product/getintegralproductdetail', {
        params: data
    })
}
